@use "@inshared/ui-foundation/css/tokens/breakpoints";
@use "link-tokens" as link;

a,
a.link {
    --color-text: #{link.$color-paragraph-normal-text};
    --color-fill: #{link.$color-paragraph-normal-fill};
    --display: #{link.$display-inline};
    --font-family: #{link.$font-family-regular};
    --font-size-medium: #{link.$font-size-medium};
    --font-size-large: #{link.$font-size-large};
    --cursor: #{link.$cursor-default};
    --color-fill-icon-start: #{link.$color-icon-start};
    --color-fill-icon-end: #{link.$color-icon-end};
    --link-gap: 0;
    --text-decoration: underline;
    --link-icon-height: #{link.$icon-size-sm};
    --link-icon-width: #{link.$icon-size-sm};

    color: var(--color-text);
    cursor: var(--cursor);
    display: var(--display);
    fill: var(--color-fill);
    font-family: var(--font-family);
    font-size: var(--font-size-medium);
    font-weight: #{link.$font-weight-normal};
    line-height: 1.5;
    min-height: 2.4rem;
    gap: var(--link-gap);
    text-decoration: var(--text-decoration);
    user-select: none;
    align-items: center;

    @media (min-width: breakpoints.$screen-desktop-min) {
        font-size: var(--font-size-large);
    }

    &:hover,
    &:focus {
        --color-text: #{link.$color-primary-hover-text};
        --color-fill: #{link.$color-primary-hover-fill};
    }

    &:active {
        --color-text: #{link.$color-primary-active-text};
        --color-box-shadow: #{link.$color-primary-active-box-shadow};
        --color-fill: #{link.$color-primary-active-fill};
    }

    &[disabled] {
        --color-text: #{link.$color-primary-disabled-text};
        --color-fill: #{link.$color-primary-disabled-fill};
        --cursor: #{link.$cursor-disabled};
    }

    &:has(web-icon, .link-icon) {
        --link-gap: #{link.$spacing-gap};
    }

    & > web-icon {
        --icon-height: var(--link-icon-height);
        --icon-width: var(--link-icon-width);
    }
}

a.link.link-primary {
    --color-text: #{link.$color-primary-normal-text};
    --color-fill: #{link.$color-primary-normal-fill};
    --text-decoration: none;
    align-items: center;

    &:hover,
    &:focus {
        --color-text: #{link.$color-primary-hover-text};
        --color-fill: #{link.$color-primary-hover-fill};
        --text-decoration: underline;
    }

    &:active {
        --color-text: #{link.$color-primary-active-text};
        --color-box-shadow: #{link.$color-primary-active-box-shadow};
        --color-fill: #{link.$color-primary-active-fill};
    }

    &[disabled] {
        --color-text: #{link.$color-primary-disabled-text};
        --color-fill: #{link.$color-primary-disabled-fill};
        --cursor: #{link.$cursor-disabled};
    }
}

a.link.link-secondary {
    --color-text: #{link.$color-primary-normal-text};
    --color-fill: #{link.$color-primary-normal-fill};
    --font-family: #{link.$font-family-secondary};
    --font-size: calc(#{link.$font-size-medium} * 1.2);

    &:hover,
    &:focus {
        --color-text: #{link.$color-primary-hover-text};
        --color-fill: #{link.$color-primary-hover-fill};
    }

    &:active {
        --color-text: #{link.$color-primary-active-text};
        --color-box-shadow: #{link.$color-primary-active-box-shadow};
        --color-fill: #{link.$color-primary-active-fill};
    }

    &[disabled] {
        --color-text: #{link.$color-primary-disabled-text};
        --color-fill: #{link.$color-primary-disabled-fill};
        --cursor: #{link.$cursor-disabled};
    }

    @media screen and (min-width: #{breakpoints.$screen-sm-min}) {
        font-size: calc(#{link.$font-size-large} * 1.2);
    }
}

a.link.link-full-width {
    --display: #{link.$display-block};
}

// tekst layout shift compensation
a.link > span {
    &:not(.link-text) {
        line-height: 2rem;
        margin-top: 0.32rem;
    }
}
